import React from "react";
import LineItemsGrid from "../lineItemsGrid";
import chevronRight from "./chevronRight.png";
import chevronDown from "./chevronDown.png";

const InvoiceForm = ({
  visibleLineItems,
  onToggleVisibleLineItems,
  selectLineItemsMode,
  onToggleSelectLineItemsMode,
  lineItems,
  changeOrder,
  jobData,
  selectedLineItems,
  onLineItemSelection,
  setFormData,
  discount,
  discountDescription,
  permitDescription,
  permitTotal,
  handleDiscountInput,
}) => {
  return (
    <>
      <div className="separator clickable" onClick={onToggleVisibleLineItems}>
        <img src={visibleLineItems ? chevronDown : chevronRight} /> Line Items
      </div>

      {visibleLineItems ? (
        <>
          <div className="formGroup">
            <LineItemsGrid
              rowData={lineItems}
              changeOrder={changeOrder}
              job={jobData?.id}
              estimateAccepted={jobData?.estimate_accepted}
              selectedLineItems={selectedLineItems}
              selectLineItemsMode={selectLineItemsMode}
              onLineItemSelection={onLineItemSelection}
              onToggleSelectLineItemsMode={onToggleSelectLineItemsMode}
              setFormData={setFormData}
              discount={discount}
              discount_description={discountDescription}
              permit_description={permitDescription}
              permit_total={permitTotal}
              handleDiscountInput={handleDiscountInput}
            />
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default InvoiceForm;
